import { defineWidget } from '../widget-types';

/**
 * Image Slider — a swipeable banner carousel. Holds N slides, each with an
 * image and an optional link; one slide renders as a static banner, several
 * render as an auto-advancing slider with dots. The page editor edits the
 * slides list (add/remove/upload per slide). props.slides is the source of
 * truth: [{ imageUrl, href?, alt? }].
 */
export const imageSliderWidget = defineWidget({
  type: 'image-slider',
  schema: {
    label: 'Image Slider',
    description: 'Swipeable banner carousel with multiple slides and links',
    props: {
      autoPlayInterval: {
        type: 'number',
        label: 'Auto-play (ms)',
        default: 4000,
      },
      aspectRatio: {
        type: 'enum',
        label: 'Aspect Ratio',
        options: ['3:4', '1:1', '4:3', '16:9', '2:1'],
        default: '3:4',
      },
    },
    slots: {},
    dataDeps: [],
  },
  nameTh: 'สไลด์รูปภาพ',
  descriptionTh: 'แบนเนอร์สไลด์เลื่อนได้ หลายรูปพร้อมลิงก์',
  category: 'content',
  thumbnail: '/widget-thumbnails/image-slider.svg',
  defaults: {
    type: 'image-slider',
    props: {
      autoPlayInterval: 4000,
      aspectRatio: '3:4',
      slides: [{ imageUrl: '', href: '' }],
    },
  },
});
